import { toast } from "react-toastify"
import { INITIATE_SESSION, UPDATE_SESSION, TERMINATE_SESSION } from "../../constants/constants"
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor"
import { fetchInitiateSessionFailure, fetchInitiateSessionSuccess } from "./reducer"
import { fetchAllSessions } from "../getAllSessions/thunk"
import { fetchDetailedBalance } from "../../customer/detailedBalance/thunk"
import { fetchCustomerSummary } from "../../customer/simulate/thunk"

// Updated initiateSession thunk
export const initiateSession = (jsonObj, setLoading, navigate, customerId, fullName, setShowForm, isView, isSimulatePage = false, resetForm = null, getEmptyFormValues = null,setSessionAction, toggle) => async (dispatch) => {
    await determineBaseUrlAndPerformApiCall(`${INITIATE_SESSION}`, 'POST', jsonObj).then((response) => {
        setLoading(true)
        if (response?.error) {
            setLoading(false)
            toast.error(`${response.error.message}`)
            dispatch(fetchInitiateSessionFailure(response.error.message))
        }
        if (response?.resultCode === "Failure") {
            setLoading(false);
            toast.error(response?.reasonCode);
            return;
        }
        else if (!response?.error) {
            setLoading(false)
            
            // Handle simulate page differently
            if (isSimulatePage && resetForm && getEmptyFormValues) {
                toast.success("Session Initiated Successfully")
                dispatch(fetchCustomerSummary(customerId, setLoading, "View"));
                dispatch(fetchAllSessions(customerId));

                // Reset the form to empty state
                resetForm({
                    values: getEmptyFormValues()
                });
                // Stay on the same page, don't navigate
                dispatch(fetchInitiateSessionSuccess(response))
                return;
            }
            
            if (isView) {
                toast.success("Session Initiated Successfully")
                dispatch(fetchAllSessions(customerId));
                dispatch(fetchDetailedBalance(response?.subscriptionId, setLoading, false))
                setSessionAction("")
                // setShowForm(false)
                navigate(`/view-customer/${customerId}`)
                dispatch(fetchCustomerSummary(customerId, setLoading, "View"));
            } else {
                navigate(`/sessions/${response?.subscriptionId}`, {
                    state: { customerId: customerId, fullName: fullName }
                })
            }
            toggle('1');
            resetForm({
                    values: getEmptyFormValues()
                });
            dispatch(fetchInitiateSessionSuccess(response))
        }
    })
}